<template>
  <pt-old-to-new class="pt-old-to-new__withData" @exportOldToNew="exportOldToNew" @bringNewStatistice="bringNewStatistice" :exportLoading="exportLoading"></pt-old-to-new>
</template>

<script>
import PtOldToNew from './index'
export default {
  name: 'pt-old-to-new__withData',
  components: {
    'pt-old-to-new': PtOldToNew
  },
  data () {
    return {
      exportLoading: false
    }
  },
  methods: {
    exportOldToNew (data) {
      this.exportLoading = true
      this.$store.dispatch('exportOldToNew', data).then(res => {
        this.exportLoading = false
        // dataExport(res)
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message.error(err || '导出脐荐康记录失败')
      })
    },
    // 发放查询
    bringNewStatistice (records, selectTab) {
      let ids = []
      records.forEach(item => {
        ids.push(item.id)
      })
      this.$store.dispatch('bringNewStatistice', ids).then(res => {
        if (!res.popupMessage) {
        //   this.$router.push('/old-to-new/batch-grant/' + selectTab)
          this.$router.push({ name: 'batch-grant', params: { recordMessage: records }, query: { type: selectTab } })
        //   this.$router.push({ name: 'batch-grant', params: { type: selectTab, recordMessage: records } })
        } else {
          let hasCanRewardUser = (selectTab === 'ALL' && res.canRewardUserTotal) || (selectTab === 'NEW' && res.canRewardNewUserTotal) || (selectTab === 'OLD' && res.canRewardOldUserTotal)
          if (hasCanRewardUser) {
            this.$confirm('您选择的' + res.selectedRecordTotal + '条脐荐康记录中，有' + res.rewardingOldUserTotal + '个老用户，' + res.rewardingNewUserTotal +
          '新用户已在发放中（待审核/已完成）状态，将为在可发放（未发放/已驳回）状态的' +
          ((selectTab !== 'NEW' && res.canRewardOldUserTotal) ? (res.canRewardOldUserTotal + '个老用户，') : '') +
          ((selectTab !== 'OLD' && res.canRewardNewUserTotal) ? (res.canRewardNewUserTotal + '个新用户') : '') + '发放脐荐康奖励', '批量发放提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning' }).then(_ => {
            //   this.$router.push('/old-to-new/batch-grant/' + selectTab)
              this.$router.push({ name: 'batch-grant', params: { recordMessage: records }, query: { type: selectTab } })
            //   this.$router.push({ name: 'batch-grant', params: { type: selectTab, recordMessage: records } })
            })
          } else {
            this.$confirm('您选择的' + records.length + '个用户中，有' + res.rewardingOldUserTotal + '个老用户，' + res.rewardingNewUserTotal +
          '新用户已在发放中（待审核/已完成）状态，尚未选择可发放的用户，请重新选择', '批量发放提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning' }).then(_ => {})
          }
        }
      }).catch(err => {
        this.$message.error(err || '查询发放数据失败')
      })
    }
  }
}
</script>
